import { ObjectId } from 'bson';
import type { Id, UserBeneficiaryCommon, UserBeneficiaryTarget } from '@hero/schema';

/** the id of the system aka Hero
 *
 * **NOTE: THIS ID MUST NEVER CHANGE**
 *
 * 680f93fb0e555d1922d87e56
 *
 */
const HERO_ORG_ID = new ObjectId('680f93fb0e555d1922d87e56');
const HERO_TARGET: UserBeneficiaryTarget = 'super_admin_system';

//* wallet
const HERO_WALLET_ID = new ObjectId('68ed524aa4d468bdb631bdcf');

//* name
const HERO_NAME = 'Hero';

//* beneficiary
const HERO_BENEFICIARY: UserBeneficiaryCommon = {
  _id: HERO_ORG_ID,
  target: HERO_TARGET,
  name: HERO_NAME,
} as const;

//* config
export const superAdmin = {
  name: HERO_NAME,
  /** the id of the system aka Hero
   *
   * **NOTE: THIS ID MUST NEVER CHANGE**
   *
   * 680f93fb0e555d1922d87e56
   *
   */
  heroId: HERO_ORG_ID,
  /** beneficiary super admin is used in reference the super admin system which means us aka Hero. */
  beneficiary: HERO_BENEFICIARY,
  /** the wallet id of the super admin.
   *
   * **THE ID MUST NEVER CHANGES**
   *
   * 68ed524aa4d468bdb631bdcf
   */
  walletId: HERO_WALLET_ID,
  /** checks if a given id matches Hero Super Admin Id or not */
  isHeroOrg: (anyOrgId: Id) => anyOrgId.toString() === HERO_ORG_ID.toString(),
} as const;
